import { render, staticRenderFns } from "./footer-primary.vue?vue&type=template&id=25e70854&scoped=true&"
import script from "./footer-primary.vue?vue&type=script&lang=js&"
export * from "./footer-primary.vue?vue&type=script&lang=js&"
import style0 from "./footer-primary.vue?vue&type=style&index=0&id=25e70854&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e70854",
  null
  
)

export default component.exports